import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@p81-common/ui';

const createClasses = makeStyles<Theme>(theme => ({
  icon: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    marginTop: theme.spacing(2)
  },
  highlight: {
    color: theme.palette.secondary[500]
  },
  text: {
    fontWeight: 500,
    color: theme.palette.primary[400]
  },
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 0)
  },
  textContainer: {
    flexDirection: 'row',
    justifyContent: 'center'
  }
}));

export default createClasses;
